export default {
  "app": {
    "name": "DeepTrade",
    "tagline": "Trading de Criptomonedas con IA",
    "description": "Señales de trading avanzadas y gestión automatizada de portafolio",
  },
  "navigation": {
    "dashboard": "Panel",
    "trading": "Trading",
    "signals": "Señales",
    "apiCredentials": "Credenciales API",
    "autoTrading": "Trading Automático",
    "tierManagement": "Gestión de Niveles",
    "referrals": "Referencias",
    "accessSecurity": "Acceso y Seguridad",
    "settings": "Configuración",
    "help": "Ayuda y Soporte",
    "login": "Iniciar Sesión",
    "register": "Registrarse",
    "logout": "Cerrar Sesión",
    "home": "Inicio",
  },
  "auth": {
    "layout": {
      "signInToAccount": "Inicia sesión en tu cuenta",
      "or": "O",
      "createNewAccount": "crear una nueva cuenta"
    },
    "login": {
      "title": "Bienvenido de Nuevo",
      "subtitle": "Ingresa tu email y contraseña para iniciar sesión",
      "email": "Email",
      "password": "Contraseña",
      "emailPlaceholder": "nombre@ejemplo.com",
      "passwordPlaceholder": "••••••••",
      "rememberMe": "Recordarme",
      "forgotPassword": "¿Olvidaste tu contraseña?",
      "signIn": "Iniciar Sesión",
      "noAccount": "¿No tienes una cuenta?",
      "signUp": "Registrarse",
      "googleSignIn": "Continuar con Google",
      "orContinueWith": "O continuar con",
      "fillAllFields": "Por favor completa todos los campos",
      "loginSuccess": "¡Inicio de sesión exitoso!",
      "loginFailed": "Error al iniciar sesión",
      "loginFailedDescription": "No se pudo iniciar sesión",
      "googleLoginFailed": "Error al iniciar el inicio de sesión con Google",
      "bySigningIn": "Al iniciar sesión, aceptas nuestros",
      "termsOfService": "Términos de Servicio",
      "privacyPolicy": "Política de Privacidad",
      "and": "y"
    },
    "register": {
      "title": "Crear Cuenta",
      "subtitle": "Ingresa tu información para crear una cuenta",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "email": "Correo Electrónico",
      "password": "Contraseña",
      "confirmPassword": "Confirmar Contraseña",
      "agreeTerms": "Al hacer clic en continuar, aceptas nuestros",
      "createAccount": "Crear cuenta",
      "hasAccount": "¿Ya tienes una cuenta?",
      "signIn": "Iniciar sesión",
      "orContinueWith": "O continuar con",
      "googleSignUp": "Registrarse con Google",
      "termsOfService": "Términos de Servicio",
      "privacyPolicy": "Política de Privacidad",
      "referralCode": "Código de Referencia (Opcional)",
      "placeholders": {
        "firstName": "Juan",
        "lastName": "Pérez",
        "email": "nombre@ejemplo.com",
        "password": "Ingresa tu contraseña",
        "confirmPassword": "Confirma tu contraseña",
        "referralCode": "Ingresa código de referencia"
      },
      "validation": {
        "minLength": "La contraseña debe tener al menos 8 caracteres",
        "uppercase": "La contraseña debe contener al menos una letra mayúscula",
        "lowercase": "La contraseña debe contener al menos una letra minúscula",
        "number": "La contraseña debe contener al menos un número",
        "specialChar": "La contraseña debe contener al menos un carácter especial"
      },
      "errors": {
        "invalidReferralCode": "Código de referencia inválido",
        "referralValidationFailed": "No se pudo validar el código de referencia. Verifica tu conexión e intenta de nuevo.",
        "googleLoginFailed": "Error al iniciar sesión con Google",
        "googleLoginFailedTitle": "Error de inicio de sesión con Google",
        "fillAllFields": "Por favor completa todos los campos",
        "requirementsNotMet": "Requisitos de Contraseña No Cumplidos",
        "passwordsDoNotMatch": "Las contraseñas no coinciden",
        "registrationFailed": "Error en el registro",
        "failedToCreateAccount": "Error al crear la cuenta",
        "emailAlreadyRegistered": "Correo ya registrado",
        "emailAlreadyRegisteredDescription": "Ya existe una cuenta con esta dirección de correo. Por favor intenta iniciar sesión.",
        "connectionError": "Error de Conexión",
        "connectionErrorDescription": "No se pudo conectar al servidor. Verifica tu conexión a internet e intenta de nuevo.",
        "referralCodeError": "Error de Código de Referencia",
        "referralCodeErrorDescription": "Hubo un problema procesando tu código de referencia. Tu cuenta aún será creada.",
        "failedToResendEmail": "Error al reenviar correo de verificación",
        "failedToResendEmailTitle": "Error al reenviar correo",
        "tryAgainLater": "Por favor intenta de nuevo más tarde."
      },
      "success": {
        "title": "¡Registro Exitoso!",
        "description": "Por favor revisa tu correo para verificar tu cuenta."
      },
      "verification": {
        "title": "Revisa Tu Correo",
        "description": "Hemos enviado un enlace de verificación a {{email}}",
        "nextSteps": "Próximos Pasos:",
        "step1": "1. Revisa tu bandeja de entrada",
        "step2": "2. Haz clic en el enlace de verificación",
        "step3": "3. Regresa aquí para iniciar sesión",
        "sending": "Enviando...",
        "resendButton": "Reenviar Correo de Verificación",
        "backToLogin": "Volver al Inicio de Sesión",
        "emailSentTitle": "Correo de Verificación Enviado",
        "emailSentDescription": "Por favor revisa tu correo para el enlace de verificación."
      },
      "referral": {
        "validating": "Validando código de referencia...",
        "validCode": "Código de referencia válido de {{referrer}}"
      }
    },
    "passwordRequirements": {
      "title": "Requisitos de Contraseña",
      "length": "Al menos 8 caracteres",
      "uppercase": "Una letra mayúscula",
      "lowercase": "Una letra minúscula",
      "number": "Un número",
      "special": "Un carácter especial",
    },
    "errors": {
      "invalidCredentials": "Email o contraseña inválidos",
      "emailRequired": "Email es requerido",
      "passwordRequired": "Contraseña es requerida",
      "passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
      "passwordsNotMatch": "Las contraseñas no coinciden",
      "emailInvalid": "Por favor ingresa una dirección de email válida",
      "termsRequired": "Debes aceptar los términos y condiciones",
    }
  },
  "dashboard": {
    "title": "Panel",
    "welcome": "¡Bienvenido de vuelta!",
    "overview": "Resumen",
    "trading": "Trading",
    "tier": "Nivel",
    "balance": "Balance",
    "pnlToday": "Ganancias y Pérdidas",
    "totalTrades": "Operaciones Totales",
    "winRate": "Tasa de Éxito",
    "activeSignals": "Señales Activas",
    "tradingOverview": "Resumen de Trading",
    "quickActions": "Acciones Rápidas",
    "viewSignals": "Ver Señales",
    "autoTrading": "Trading Automático",
    "autoTradingDescription": "Ejecutar señales de trading automáticamente",
    "currentTier": "Nivel Actual",
    "progressTo": "Progreso al Nivel {{tier},",
    "yourBenefits": "Tus Beneficios",
    "advancedSignals": "Señales de Trading Avanzadas",
    "autoTradingFeatures": "Funciones de Trading Automático",
    "prioritySupport": "Soporte Prioritario",
    "monthlyRate": "Tasa Mensual",
    "currentMonthRate": "Este Mes",
    "monthlyAvgLabel": "Prom. Mensual",
    "symbolSelector": "Símbolo",
    "profitShare40": "40% participación en ganancias",
    "profitShare20": "20% participación en ganancias",
    "profitShare10": "10% participación en ganancias",
    "verifyingNFT": "Verificando propiedad del NFT...",
    "debt": "Deuda",
    "btcPrice": {
      "symbol": "BTC/USDT",
      "loading": "BTC/USDT: Cargando...",
      "unavailable": "BTC/USDT: --",
      "connecting": "Conectando...",
      "live": "En Vivo",
      "error": "Error ({{count}})",
      "24h": "24h",
    },
    "controls": {
      "turnOn": "Activar",
      "turnOff": "Desactivar",
      "paperAutoTrading": "Trading Automático de Prueba",
    },
    "forecast": {
      "title": "Pronóstico de Precios",
      "refresh": "Actualizar",
      "errorLoading": "Error cargando gráfico",
      "retry": "Reintentar",
      "noData": "No hay datos de gráfico disponibles",
    },
    "tradingChart": {
      "forecast": "Pronóstico",
      "upperBound": "Límite superior",
      "lowerBound": "Límite inferior",
      "support": "Soporte",
      "resistance": "Resistencia",
      "entry": "Entrada",
      "stopLoss": "Stop loss",
      "takeProfit": "Take profit",
      "partialTakeProfit": "TP parcial",
      "liquidation": "Liquidación",
      "locked": "Bloqueado",
      "positionLevelDialogTitle": "Confirmar actualización de {{level}}",
      "positionLevelDialogDescription": "¿Establecer {{level}} para {{symbol}} {{side}} de {{currentPrice}} a {{newPrice}}?",
      "positionLevelDelta": "Cambio: {{delta}}%",
      "positionLevelConfirm": "Actualizar {{level}}",
      "positionLevelCancel": "Cancelar",
      "positionLevelProcessing": "Actualizando...",
      "positionLevelSuccess": "{{level}} actualizado",
      "positionLevelSuccessDesc": "{{symbol}} {{side}} · nuevo {{level}}: {{price}}",
      "positionLevelFailure": "Error al actualizar {{level}}",
      "positionLevelFailureDesc": "Se restauró el nivel anterior. {{error}}",
      "dragHint": "Arrastra para mover · suelta para confirmar",
      "indicators": {
        "title": "Indicadores",
        "overlays": "Superposiciones",
        "panes": "Paneles",
        "levels": "Niveles",
        "keyLevels": "Niveles clave (S/R)",
        "reset": "Restablecer indicadores",
        "ema20": "EMA 20",
        "ema50": "EMA 50",
        "ema200": "EMA 200",
        "sma20": "SMA 20",
        "sma50": "SMA 50",
        "bb20": "Bandas de Bollinger (20, 2)",
        "bbUpper": "Bollinger superior",
        "bbMiddle": "Bollinger media",
        "bbLower": "Bollinger inferior",
        "vwap": "VWAP",
        "rsi14": "RSI (14)",
        "macd": "MACD (12, 26, 9)",
        "macdSignal": "Señal MACD",
      },
      "drawing": {
        "toolbar": "Herramientas de dibujo",
        "select": "Seleccionar",
        "magnetMode": "Imán: {{mode}}",
        "stayInDrawingMode": "Mantener modo dibujo",
        "hideAll": "Ocultar todos los dibujos",
        "showAll": "Mostrar todos los dibujos",
        "undo": "Deshacer",
        "redo": "Rehacer",
        "deleteSelected": "Eliminar dibujos seleccionados",
        "clearAll": "Borrar todos los dibujos",
        "moreTools": "Más herramientas de dibujo",
        "export": "Exportar dibujos",
        "import": "Importar dibujos",
        "textPrompt": "Introduce el texto del dibujo",
        "loadFailure": "Herramientas de dibujo no disponibles",
        "importEmpty": "No se encontraron dibujos en este archivo",
        "importSuccess": "{{count}} dibujos importados",
        "importFailure": "No se pudieron importar los dibujos",
        "clearConfirmTitle": "¿Borrar todos los dibujos?",
        "clearConfirmDescription": "Esto elimina todos los dibujos del símbolo y marco temporal actual. No se puede deshacer.",
        "categories": {
          "lines": "Líneas",
          "channels": "Canales",
          "fibonacci": "Fibonacci y Gann",
          "patterns": "Patrones",
          "elliott": "Elliott",
          "forecasting": "Pronóstico y medición",
          "volume": "Volumen",
          "annotations": "Anotaciones",
          "shapes": "Formas",
          "cycles": "Ciclos",
          "regression": "Regresión",
        },
        "tools": {
          "trend-line": "Línea de tendencia",
          "horizontal-line": "Línea horizontal",
          "vertical-line": "Línea vertical",
          "ray": "Rayo",
          "parallel-channel": "Canal paralelo",
          "fib-retracement": "Retroceso de Fib",
          "trend-based-fib-extension": "Extensión de Fib por tendencia",
          "rectangle": "Rectángulo",
          "text": "Texto",
          "arrow": "Flecha",
          "brush": "Pincel",
          "price-range": "Rango de precio",
          "long-position": "Posición larga",
          "short-position": "Posición corta",
        },
      },
    },
    "realTimePerformance": "Rendimiento en Tiempo Real",
    "riskSettings": {
      "title": "Configuración de Gestión de Riesgo",
      "paperTradingTitle": "Configuración de Gestión de Riesgo - Trading de Simulación",
      "loading": "Cargando configuración de riesgo...",
      "investmentPercentage": "Porcentaje de Inversión",
      "investmentDescription": "Porcentaje del balance a usar para trading (0% - 10%)",
      "leverage": "Apalancamiento",
      "leverageDescription": "Máx: {{max}}x para Nivel {{tier}} + {{exchange}} {{market},",
      "paperTradingLeverageDesc": "En modo simulación, puedes usar cualquier configuración de apalancamiento para pruebas",
      "exchange": "Exchange: ",
      "configureCredentials": "Configurar en Credenciales API",
      "warningZeroInvestment": "Selecciona porcentaje de inversión > 0% para habilitar trading",
      "paperTradingNote": "Modo trading de simulación - no aplican limitaciones de nivel",
      "saveSettings": "Guardar Configuración",
      "saving": "Guardando...",
      "resetToSafe": "Restablecer a Seguro",
      "confirmSaveTitle": "Confirmar Configuración de Riesgo",
      "confirmSaveDesc": "¿Estás seguro de que quieres guardar esta configuración de riesgo?\n\nInversión: {{investment}}%\nApalancamiento: {{leverage}}x\nModo: {{mode}}",
      "confirmSave": "Guardar Configuración",
      "saveSuccess": "Configuración Guardada",
      "saveSuccessDesc": "Tu configuración de gestión de riesgo se ha guardado exitosamente.",
      "saveError": "Error al Guardar",
      "tradingStrategy": "Estrategia de Trading",
      "strategyActive": "Estrategia Estándar",
      "strategyConservative": "Estrategia Neural AI",
      "strategyActiveBadge": "Recomendado",
      "strategyActiveDesc": "Operaciones más frecuentes basadas en predicciones de precios ML. Genera 3-8 señales por día con 75-80% de precisión esperada. Ideal para traders que quieren más oportunidades y pueden manejar actividad moderada.",
      "strategyConservativeDesc": "Menos operaciones con mayor confianza y confirmaciones estrictas. Genera 1-3 señales por día con 85-90% de precisión esperada. Ideal para traders conservadores que prefieren calidad sobre cantidad.",
      "gridTradingTitle": "Grid Trading",
      "gridEnabledLabel": "Habilitar Grid Trading",
      "trailingStopTitle": "Trailing Stop",
      "trailingStopEnabledLabel": "Habilitar Trailing Stop",
      "tradingSymbolsLabel": "Símbolos de Trading",
      "tradingSymbolsHint": "Solo los símbolos marcados operan automáticamente",
      "tradingSymbolsEmptyWarning": "Ningún símbolo seleccionado: el auto-trading no abrirá operaciones para esta cuenta.",
      "signalsPerDay": "Señales por Día",
      "expectedAccuracy": "Precisión Esperada",
      "tradeFrequency": "Frecuencia de Trading",
      "riskLevel": "Nivel de Riesgo",
      "profitPotential": "Potencial de Ganancia",
      "bestFor": "Mejor Para",
      "activeTraders": "Traders activos que quieren más oportunidades",
      "conservativeTraders": "Traders conservadores que prefieren calidad sobre cantidad",
      "high": "Alto",
      "low": "Bajo",
      "moderate": "Moderado",
      "higher": "Mayor",
      "viewComparison": "Ver Comparación",
      "hideComparison": "Ocultar Comparación",
      "testForecastStrategy": "Probar Estrategia de Pronóstico",
      "testingStrategy": "Probando Estrategia...",
      "testStrategyDesc": "Haz clic para probar si la estrategia de pronóstico abriría una operación ahora mismo",
      "paperSettingsError": "Error de Configuración de Prueba",
      "paperSettingsErrorDesc": "Error al cargar la configuración de riesgo del trading de prueba.",
      "settingsLoadError": "Error de Carga de Configuración",
      "settingsLoadErrorDesc": "Error al cargar la configuración de riesgo. Por favor, actualiza la página.",
      "configurationRequired": "Configuración Requerida",
      "configurationRequiredDesc": "Por favor, establece un porcentaje de inversión superior al 0% antes de probar la estrategia.",
      "noTradeSignal": "Sin Señal de Trading",
      "noTradeSignalDesc": "El pronóstico muestra movimiento insuficiente. Ascendente: {{upward}}%, Descendente: {{downward}}%. Se necesita >0.5% para activar el trading.",
      "strategyTestSuccessful": "Prueba de Estrategia Exitosa",
      "strategyTestSuccessfulDesc": "Señal {{direction}} detectada con {{movement}}% de movimiento potencial. {{result}}",
      "paperTradeOpened": "¡Operación de prueba abierta exitosamente!",
      "tradeSimulationCompleted": "Simulación de operación completada.",
      "strategyTestFailed": "Prueba de Estrategia Fallida",
      "strategyTestFailedDesc": "Error desconocido ocurrido durante la prueba de estrategia.",
      "strategyTestError": "Error de Prueba de Estrategia",
      "strategyTestErrorDesc": "Error al probar la estrategia de pronóstico.",
    },
    "activePositions": {
      "title": "Posiciones Activas",
      "tabs": {
        "all": "todas",
        "app": "app",
        "external": "externas",
      },
      "refresh": "Actualizar",
      "errorLoading": "Error cargando posiciones activas",
      "retry": "Reintentar",
      "noPositions": "No hay posiciones activas.",
      "noPositionsDesc": "Tus posiciones de trading activas aparecerán aquí una vez que comiences a operar o habilites el auto-trading.",
      "noAppPositions": "No hay posiciones activas de la app.",
      "noExternalPositions": "No hay posiciones externas activas.",
      "addCredentialsWarning": " Agrega credenciales API para ver posiciones externas",
      "externalError": "❌ Error en posiciones externas: {{error},",
      "externalErrorGeneric": "❌ {{error},",
      "diagnostics": "App: {{app}} | Externas: {{external},",
      "fields": {
        "size": "Tamaño",
        "entryPrice": "Precio de Entrada",
        "currentPrice": "Precio Actual",
        "margin": "Margen",
        "liquidationPrice": "Precio Liq.",
        "marginRate": "Tasa de Margen",
        "takeProfit": "TP",
        "stopLoss": "SL",
        "roi": "ROE",
        "none": "Ninguno",
        "na": "N/A",
      },
      "positionTypes": {
        "appPositions": "Posiciones de la App",
        "externalPositions": "Posiciones Externas",
      },
      "exposureWarningTitle": "Exposicion del exchange detectada",
      "exposureWarningMixedDesc": "DeepTrade detecto posiciones externas del exchange junto con operaciones gestionadas por la app. Revisa los totales de la pestaña All contra tu exchange antes de habilitar el auto-trading.",
      "exposureWarningExternalOnlyDesc": "DeepTrade detecto posiciones externas del exchange que no estan gestionadas por la app. Revisa tu exposicion en el exchange antes de habilitar el auto-trading.",
      "headers": {
        "symbol": "Símbolo",
        "size": "Tamaño",
        "entryPrice": "Precio de Entrada",
        "markPrice": "Precio de Marca",
        "liqPrice": "Precio de Liq.",
        "margin": "Margen",
        "pnlRoi": "PNL (ROE %)",
        "tpSl": "TP/SL",
        "actions": "Acciones",
      },
      "close": "Cerrar",
      "closing": "Cerrando...",
      "featureNotAvailable": "Función No Disponible",
      "positionClosingPaperOnly": "El cierre de posiciones actualmente solo está disponible en el modo de Trading de Prueba.",
      "tpSlPaperOnly": "TP/SL actualmente solo está disponible en el modo de Trading de Prueba.",
      "positionClosed": "Posición Cerrada",
      "positionClosedDesc": "Posición cerrada exitosamente. PnL: ${{pnl}}",
      "errorClosingPosition": "Error al Cerrar Posición",
      "errorClosingPositionDesc": "Error al cerrar la posición",
      "takeProfitSet": "Take Profit Establecido",
      "takeProfitSetDesc": "Take profit establecido en ${{price}}",
      "errorSettingTakeProfit": "Error al Establecer Take Profit",
      "errorSettingTakeProfitDesc": "Error al establecer Take Profit",
      "stopLossSet": "Stop Loss Establecido",
      "stopLossSetDesc": "Stop loss establecido en ${{price}}",
      "errorSettingStopLoss": "Error al Establecer Stop Loss",
      "errorSettingStopLossDesc": "Error al establecer Stop Loss",
      "position": "posición",
      "positions": "posiciones",
      "allPositions": "Todas las Posiciones",
      "noApiCredentials": "Sin credenciales API conectadas",
    },
    "debug": {
      "testSuccessful": "Prueba de Trading Debug Exitosa",
      "paperTradeOpened": "¡Operación de prueba abierta exitosamente!",
      "tradeSimulationCompleted": "Simulación de operación completada.",
      "testFailed": "Prueba de Trading Debug Fallida",
      "unknownError": "Error desconocido ocurrido durante la prueba de trading debug.",
      "testError": "Error de Prueba Debug",
      "testErrorDesc": "Error al probar la apertura de operación.",
    },
    "profitShare": {
      "title": "Seguimiento de Participación en Ganancias",
      "loading": "Cargando datos de participación en ganancias...",
      "noData": "No hay datos de participación en ganancias disponibles. Comienza a hacer trading para rastrear tus ganancias.",
      "balanceOverview": "Resumen de Balance",
      "initialBalance": "Balance Inicial:",
      "currentBalance": "Balance Actual:",
      "netDeposits": "Depósitos Netos:",
      "profitAnalysis": "Análisis de Ganancias",
      "tradingProfit": "Ganancia de Trading:",
      "trueProfit": "Ganancia Real:",
      "profitPercentage": "% de Ganancia:",
      "profitShareInfo": "Participación en Ganancias",
      "tierRate": "Tasa Nivel {{tier}}:",
      "amountOwed": "Cantidad Adeudada:",
      "status": "Estado:",
      "profitable": "La cuenta está en ganancias - La participación en ganancias se aplica a las ganancias por encima del balance inicial",
      "notProfitable": "La cuenta aún no es rentable - No hay participación en ganancias hasta que el balance exceda el inicial + depósitos",
      "profitableDescription": "Tu balance está por encima de tu capital inicial y depósitos. Las tarifas de participación en ganancias se calcularán sobre las ganancias mostradas arriba.",
      "notProfitableDescription": "Sigue operando para superar tu capital inicial más depósitos. Hasta entonces, no se adeuda participación en ganancias.",
      "paymentRequired": "Pago Requerido",
      "paymentDescription": "Tienes ${{amount}} en tarifas de participación en ganancias por pagar.",
      "payNow": "Pagar Ahora",
      "viewDetails": "Ver detalles de participación",
    },
    "tradingHistory": {
      "title": "Historial de Trading (Solo Operaciones de la App)",
      "description": "Mostrando operaciones iniciadas por la plataforma DeepTrade",
      "loading": "Cargando...",
      "errorTitle": "No se pudo cargar el historial de trading",
      "errorMessage": "No pudimos obtener tu historial de trading en vivo. Intenta nuevamente o verifica tus credenciales de exchange antes de refrescar.",
      "headers": {
        "date": "Fecha",
        "symbol": "Símbolo",
        "side": "Lado",
        "size": "Tamaño",
        "entry": "Entrada",
        "exit": "Salida",
        "fees": "Comisiones",
        "pnl": "P&L Bruto",
        "status": "Estado",
      },
      "noHistory": "No se encontró historial de trading. Comienza a hacer trading para ver tu historial aquí.",
      "pagination": "Página {{page}} de {{pages}} ({{total}} operaciones totales)",
      "previous": "Anterior",
      "next": "Siguiente",
    },
    "blockedUser": {
      "title": "Trading Bloqueado:",
      "message": "Participación en ganancias impaga para tu nivel ({{tier}}). Adeudado: ${{owed}}. Por favor liquida tu balance para continuar.",
    },
    "tooltips": {
      "balance": "Su saldo de cuenta actual de su exchange conectado.",
      "pnlToday": "Ganancia y pérdida realizada de operaciones cerradas hoy.",
      "monthlyRate": "Su tasa de retorno mensual como porcentaje.",
      "currentMonthRate": "Ganancia realizada del mes calendario en curso (hasta la fecha), como porcentaje de su saldo al inicio del mes.",
      "monthlyAvgRate": "Ganancia mensual promedio de los meses completos transcurridos desde su primera operación.",
      "symbolSelector": "Cambia el gráfico de pronóstico de precios y el ticker de precio del encabezado entre los pares ofrecidos.",
      "winRate": "Porcentaje de sus operaciones que fueron rentables."
    }
  },
  "performanceAnalytics": {
    "title": "Analíticas de Rendimiento",
    "paperMode": "Simulación",
    "liveMode": "Real",
    "refresh": "Actualizar datos de rendimiento",
    "noTrades": "Aún no hay operaciones cerradas: las analíticas aparecerán después de su primera operación cerrada.",
    "viewCumulative": "Acumulativo",
    "viewMonthly": "Mensual",
    "viewStatistics": "Estadísticas",
    "groupReturns": "Rentabilidad",
    "groupRisk": "Riesgo",
    "groupTrades": "Operaciones",
    "expectancyUsd": "Expectativa",
    "expectancyR": "Expectativa (R)",
    "profitFactor": "Factor de Beneficio",
    "maxDrawdownPct": "DD Máx %",
    "drawdownDuration": "Duración DD",
    "recoveryFactor": "Factor de Recuperación",
    "sharpe": "Sharpe",
    "sortino": "Sortino",
    "avgWin": "Ganancia Media",
    "avgLoss": "Pérdida Media",
    "maxConsecWins": "Victorias Consec.",
    "maxConsecLosses": "Derrotas Consec.",
    "bestTrade": "Mejor Operación",
    "worstTrade": "Peor Operación",
    "avgDuration": "Duración Media",
    "feesPaid": "Comisiones Pagadas",
    "exitReasonsTitle": "Motivos de Salida",
    "rDistribution": "Distribución de Múltiplos R",
    "daysUnit": "d",
    "hoursUnit": "h",
    "range7d": "7D",
    "range30d": "30D",
    "rangeYtd": "AAT",
    "range1y": "1A",
    "rangeAll": "Todo",
    "sideBySide": "Drawdown debajo del profit",
    "cumulativeProfit": "Profit Acumulado",
    "drawdown": "Drawdown",
    "monthlyPnl": "P&L Mensual",
    "monthlyAvg": "Prom. Mensual",
    "profitUsd": "Profit (USD)",
    "drawdownUsd": "Drawdown (USD)",
    "totalPnl": "P&L Total",
    "currentMonth": "Este Mes",
    "maxDrawdown": "Drawdown Máximo",
    "winRate": "Tasa de Aciertos",
    "totalTrades": "Operaciones",
    "bySymbol": "Por Símbolo",
    "symbol": "Símbolo",
    "pnl": "P&L",
    "trades": "Operaciones"
  },
  "trading": {
    "title": "Trading",
    "signals": "Señales",
    "positions": "Posiciones",
    "history": "Historial",
    "long": "Largo",
    "short": "Corto",
    "autoTrading": "Trading Automático",
    "autoTradingActive": "Trading Automático Activo",
    "autoTradingDisabled": "Trading Automático Deshabilitado",
    "autoTradingActiveDesc": "Las señales se ejecutarán automáticamente",
    "autoTradingDisabledDesc": "Habilita para ejecutar señales automáticamente",
    "noActiveSignals": "Sin Señales Activas",
    "waitingForSignals": "Esperando nuevas oportunidades de trading...",
    "enableAutoTrading": "Habilita el trading automático para recibir señales",
    "refreshSignals": "Actualizar Señales",
    "noOpenPositions": "Sin Posiciones Abiertas",
    "positionsDesc": "Tus posiciones de trading activas aparecerán aquí",
    "noTradingHistory": "Sin Historial de Trading",
    "historyDesc": "Tus operaciones completadas aparecerán aquí",
    "executeTradeButton": "Ejecutar Operación",
    "viewDetailsButton": "Ver Detalles",
    "entry": "Entrada",
    "stopLoss": "Stop Loss",
    "takeProfit": "Take Profit",
    "confidence": "{{value}}% confianza",
    "strategy": "Estrategia",
    "firstTp": "Primer TP",
    "secondTp": "Segundo TP",
    "autoMoveStopLoss": "Mover SL automáticamente al punto de equilibrio después del primer TP",
    "tradingMode": "Modo de Trading",
    "paperMode": "Simulación",
    "liveMode": "Real",
    "paperTradingActive": "Trading de Simulación Activo",
    "liveTradingActive": "Trading Real Activo",
    "paperTradingDesc": "Practica trading con fondos virtuales",
    "liveTradingDesc": "Opera con dinero real",
    "virtualBalance": "Saldo Virtual",
    "unrealizedPnL": "P&L No Realizado",
    "equity": "Patrimonio",
    "paperTradingHelp": "Ayuda de Trading de Simulación",
    "resetAccount": "Reiniciar Cuenta",
    "paperTradingGuide": "Guía de Trading de Simulación",
    "paperModeTitle": "Modo Simulación",
    "noProfitSharePaper": "Sin participación de ganancias en modo simulación",
    "paperTradingPositions": "Total de Posiciones:",
    "paperTradingHistory": "Historial de Trading de Simulación",
    "simulatedTradingHistory": "Historial de trading simulado",
    "noPaperPositions": "Sin posiciones de trading de simulación",
    "enableAutoTradingPaper": "El trading de simulación generará automáticamente posiciones simuladas basadas en señales del mercado",
    "paperTradingMode": "Modo Trading de Simulación",
    "autoTradingNotAvailable": "Trading Automático No Disponible",
    "autoTradingDisabledPaper": "El trading automático controla el trading en vivo. El trading de simulación genera señales automáticamente.",
    "riskManagement": "Gestión de Riesgo",
    "riskSettings": "Configuración de Riesgo",
    "investmentPercentage": "Porcentaje de Inversión",
    "leverage": "Apalancamiento",
    "maxLeverage": "Apalancamiento Máximo",
    "currentTier": "Nivel Actual",
    "exchange": "Exchange",
    "accountType": "Tipo de Cuenta",
    "marketType": "Tipo de Mercado",
    "saveSettings": "Guardar Configuración",
    "resetToSafe": "Restablecer a Seguro",
    "saving": "Guardando...",
    "riskSettingsSaved": "Configuración de riesgo guardada exitosamente",
    "failedToSaveRiskSettings": "Error al guardar configuración de riesgo",
    "position": "posición",
    "internal": "Interno",
    "external": "Externo",
    "marketClose": "Cerrar MKT",
    "reverse": "Revertir",
    "editTpSl": "TP/SL",
    "refreshActivePositions": "Actualizar Posiciones Activas",
    "youHaveNoPosition": "No tienes posiciones.",
    "noActiveAppPositions": "No se encontraron posiciones activas de la app.",
    "noActiveExternalPositions": "No se encontraron posiciones externas activas.",
    "yourActivePositionsWillAppear": "Tus posiciones de trading activas aparecerán aquí.",
    "previous": "Anterior",
    "next": "Siguiente",
    "learnMore": "Aprender Más",
    "paperTradingLabel": "Trading de Simulación",
    "recentPaperTrades": "Operaciones de Simulación Recientes",
    "noPaperTrades": "Aún no hay operaciones de simulación",
    "paperTradingAutoGenerate": "El trading de simulación generará automáticamente operaciones simuladas basadas en señales del mercado",
    "activePositionsTitle": "Posiciones Activas",
    "youHaveNoPositions": "No tienes posiciones.",
    "yourActivePositionsWillAppearHere": "Tus posiciones de trading activas aparecerán aquí una vez que comiences a operar o habilites el trading automático.",
    "max": "Máx",
    "tooltips": {
      "virtualBalance": "Su saldo realizado de operaciones cerradas. Calculado como: Saldo Inicial + P&L Neto Total de todas las operaciones cerradas.",
      "unrealizedPnL": "Ganancia o pérdida de sus posiciones actualmente abiertas. Este valor cambia en tiempo real según los precios actuales del mercado y aún no está realizado.",
      "equity": "El valor total de su cuenta incluyendo posiciones abiertas. Calculado como: Saldo Virtual + P&L No Realizado. Esto representa su patrimonio neto actual en trading de simulación.",
      "profitAndLoss": "Ganancia y pérdida realizada solo de operaciones cerradas. Esto no incluye el P&L no realizado de posiciones abiertas.",
      "balance": "Su saldo de cuenta actual disponible para operar.",
      "pnlToday": "Ganancia y pérdida realizada de operaciones cerradas hoy.",
      "monthlyRate": "Su tasa de retorno mensual calculada como porcentaje de su saldo inicial.",
      "winRate": "Porcentaje de operaciones cerradas que fueron rentables. Calculado solo de operaciones completadas.",
      "totalReturn": "Su porcentaje de retorno total basado en el Saldo Virtual. Calculado como: (Saldo Virtual Actual - Saldo Inicial) / Saldo Inicial × 100%."
    }
  },
  "common": {
    "loading": "Cargando...",
    "error": "Error",
    "success": "Éxito",
    "warning": "Advertencia",
    "confirm": "Confirmar",
    "cancel": "Cancelar",
    "save": "Guardar",
    "edit": "Editar",
    "delete": "Eliminar",
    "close": "Cerrar",
    "back": "Atrás",
    "next": "Siguiente",
    "yes": "Sí",
    "no": "No",
    "active": "Activo",
    "inactive": "Inactivo",
    "on": "ENCENDIDO",
    "off": "APAGADO",
    "enabled": "habilitado",
    "disabled": "deshabilitado",
    "for": "para",
    "info": "Información",
    "previous": "Anterior",
    "submit": "Submit",
    "reset": "Reset",
    "search": "Search",
    "filter": "Filter",
    "sort": "Sort",
    "refresh": "Refresh",
    "enable": "Habilitar",
    "disable": "Deshabilitar",
    "toggleOn": "ON",
    "toggleOff": "OFF",
    "ok": "OK",
    "apply": "Aplicar",
    "clear": "Limpiar",
    "select": "Seleccionar",
    "upload": "Subir",
    "download": "Descargar",
    "copy": "Copiar",
    "copied": "¡Copiado!",
    "share": "Share",
    "print": "Imprimir",
    "export": "Export",
    "import": "Import",
    "and": "y",  },
  "wallet": {
    "connect": "Conectar Billetera",
    "disconnect": "Desconectar",
    "connected": "Conectado",
    "notConnected": "No Conectado",
    "connecting": "Conectando...",
    "balance": "Balance",
    "address": "Dirección",
    "solanaBlockchain": "Impulsado por Blockchain Solana",
    "solanaTooltip": "Construido en Solana - Blockchain rápida, segura y escalable",
    "wrongNetwork": "Red Incorrecta",
    "switchNetwork": "Cambiar Red",
    "transactionPending": "Transacción Pendiente",
    "transactionConfirmed": "Transacción Confirmada",
    "transactionFailed": "Transacción Fallida",
    "connectionError": "Error de Conexión",
    "connectionFailed": "Error al conectar billetera",
    "connectionRejected": "La conexión de billetera fue rechazada",
    "walletNotFound": "No se encontró billetera Solana. Por favor instala una billetera como Phantom.",
    "disconnected": "Billetera Desconectada",
    "disconnectedSuccess": "Tu billetera ha sido desconectada exitosamente.",
    "disconnectError": "Error de Desconexión",
    "disconnectFailed": "Error al desconectar billetera.",
    "confirmDisconnect": "Confirmar Desconexión de Billetera",
    "confirmDisconnectMessage": "¿Estás seguro de que quieres desconectar tu billetera?",
  },
  "notifications": {
    "autoTradingEnabled": "El trading automático ha sido habilitado",
    "autoTradingDisabled": "El trading automático ha sido deshabilitado",
    "settingsSaved": "Configuraciones guardadas exitosamente",
    "passwordChanged": "Contraseña cambiada exitosamente",
    "profileUpdated": "Perfil actualizado exitosamente",
    "walletConnected": "Billetera conectada exitosamente",
    "walletDisconnected": "Billetera desconectada",
    "signalExecuted": "Señal de trading ejecutada",
    "tradeCompleted": "Operación completada exitosamente",
    "paymentSuccessful": "Pago procesado exitosamente",
    "tierUpgraded": "Nivel actualizado exitosamente",
    "autoTrading": {
      "enabledTitle": "Trading Automático Habilitado",
      "enabledDescription": "El trading automático ha sido habilitado exitosamente. Requisito de balance verificado.",
      "disabledTitle": "Trading Automático Deshabilitado",
      "disabledDescription": "El trading automático ha sido deshabilitado exitosamente.",
      "insufficientBalanceTitle": "Balance Insuficiente",
      "insufficientBalanceDescription": "Se requiere un balance mínimo de {{required}} USDT. Tu balance actual es {{current}} USDT.",
      "missingCredentialsTitle": "Credenciales API Faltantes",
      "missingCredentialsDescription": "Por favor agrega y valida tus credenciales API del exchange primero.",
      "balanceVerificationFailedTitle": "Verificación de Balance Fallida",
      "balanceVerificationFailedDescription": "Falló la verificación del balance de la cuenta. Por favor verifica tus credenciales API.",
      "errorTitle": "Error de Trading Automático",
      "errorDescription": "Falló el cambio de trading automático. Por favor intenta de nuevo.",
      "systemDisabledTitle": "Trading Automático Deshabilitado",
      "noApiCredentialsReason": "Sin credenciales API del exchange configuradas. Por favor agrega tus claves API.",
      "investmentPercentageReason": "El porcentaje de inversión está establecido en 0%. Por favor ajusta tu configuración de riesgo.",
    },
    "paperAutoTrading": {
      "enabledTitle": "Trading Automático de Papel Habilitado",
      "enabledDescription": "Las señales de trading de papel ahora se ejecutarán automáticamente",
      "disabledTitle": "Trading Automático de Papel Deshabilitado",
      "disabledDescription": "Las señales de trading de papel ya no se ejecutarán automáticamente",
      "errorTitle": "Error de Trading Automático de Papel",
      "errorDescription": "Falló el cambio de trading automático de papel"
    }
  },
  "pagination": {
    "show": "Mostrar",
    "perPage": "por página",
    "showing": "Mostrando {{start}} a {{end}} de {{total}} registros",
    "previous": "Anterior",
    "next": "Siguiente"
  },
  "errors": {
    "generic": "Algo salió mal. Por favor intenta de nuevo.",
    "network": "Error de red. Por favor verifica tu conexión.",
    "unauthorized": "No estás autorizado para realizar esta acción.",
    "forbidden": "Acceso denegado.",
    "notFound": "El recurso solicitado no fue encontrado.",
    "serverError": "Error del servidor. Por favor intenta más tarde.",
    "validationError": "Por favor verifica tu entrada e intenta de nuevo.",
    "walletNotConnected": "Por favor conecta tu billetera primero.",
    "insufficientBalance": "Balance insuficiente.",
    "transactionFailed": "Transacción fallida. Por favor intenta de nuevo.",
    "apiError": "Error de API. Contacta soporte si esto persiste.",
  },
  "settings": {
    "title": "Configuración",
    "pleaseLogIn": "Por Favor Inicia Sesión",
    "loginRequired": "Necesitas iniciar sesión para acceder a la configuración.",
    "goToLogin": "Ir a Iniciar Sesión",
    "profile": {
      "title": "Información del Perfil",
      "description": "Actualiza la información de tu perfil de cuenta.",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "email": "Dirección de Email",
      "updateProfile": "Actualizar Perfil",
      "updateEmail": "Actualizar Email",
      "sending": "Enviando...",
      "profileUpdated": "Perfil actualizado exitosamente",
      "placeholders": {
        "newEmail": "Ingresa nueva dirección de email",
        "currentPassword": "Ingresa tu contraseña actual"
      }
    },
    "security": {
      "title": "Configuración de Seguridad",
      "description": "Gestiona la seguridad y autenticación de tu cuenta.",
      "currentPassword": "Contraseña Actual",
      "newPassword": "Nueva Contraseña",
      "confirmPassword": "Confirmar Nueva Contraseña",
      "changePassword": "Cambiar Contraseña",
      "changePasswordButton": "Cambiar Contraseña",
      "changing": "Cambiando...",
      "passwordChanged": "Contraseña cambiada exitosamente",
      "enable2FA": "Habilitar Autenticación de Dos Factores",
      "disable2FA": "Deshabilitar Autenticación de Dos Factores",
      "disable2FAButton": "Deshabilitar 2FA",
      "disabling": "Deshabilitando...",
      "disable2FADescription": "¿Estás seguro de que quieres deshabilitar la autenticación de dos factores? Esto hará tu cuenta menos segura.",
      "sendVerificationCode": "Enviar Código de Verificación",
      "verifyEmail": "Verificar Email",
      "verifyEmailDescription": "Hemos enviado un código de verificación de 6 dígitos a tu dirección de email. Por favor ingrésalo abajo para habilitar 2FA.",
      "verifyEmailToDisable2FA": "Verificar Email para Deshabilitar 2FA",
      "verifyEmailToDisable2FADescription": "Hemos enviado un código de verificación de 6 dígitos a tu dirección de email. Por favor ingrésalo abajo para deshabilitar 2FA.",
      "verificationCode": "Código de Verificación",
      "verifyCode": "Verificar Código",
      "verifying": "Verificando...",
      "resendCode": "Reenviar Código",
      "cancel": "Cancelar",
      "twoFactorEnabled": "La autenticación de dos factores está habilitada",
      "twoFactorDisabled": "La autenticación de dos factores está deshabilitada",
      "placeholders": {
        "currentPassword": "Ingresa tu contraseña actual",
        "newPassword": "Ingresa tu nueva contraseña",
        "confirmPassword": "Confirma tu nueva contraseña",
        "verificationCode": "Ingresa código de 6 dígitos"
      }
    },
    "language": {
      "title": "Idioma y Preferencias",
      "description": "Personaliza tu idioma y preferencias de visualización.",
      "selectLanguage": "Idioma",
      "languageDescription": "Elige tu idioma preferido para la interfaz.",
    },
    "account": {
      "title": "Gestión de Cuenta",
      "description": "Gestiona la configuración y datos de tu cuenta.",
      "deleteAccount": "Eliminar Cuenta",
      "deleteAccountButton": "Eliminar Cuenta",
      "deleting": "Eliminando...",
      "deleteAccountWarning": "Esta acción no se puede deshacer. Esto eliminará permanentemente tu cuenta y removerá tus datos de nuestros servidores.",
      "confirmDelete": "Escribe 'DELETE' para confirmar",
      "accountDeleted": "Cuenta eliminada exitosamente",
      "deleteAccountModal": {
        "title": "Eliminar Cuenta",
        "description": "¿Estás seguro de que quieres eliminar permanentemente tu cuenta?",
        "confirmText": "Eliminar Cuenta",
        "typedConfirmationText": "DELETE",
        "permanentlyDelete": "Esto eliminará permanentemente:",
        "consequences": [
          "Todos tus datos de trading e historial",
          "Tu perfil de cuenta y configuraciones",
          "Cualquier suscripción o pago activo",
          "Acceso a todos los servicios de DeepTrade"
        ]
      },
      "deactivated": {
        "title": "Cuenta Desactivada",
        "message": "Tu cuenta ha sido desactivada y el acceso a las funciones de trading está restringido.",
        "nextSteps": "Qué hacer a continuación:",
        "step1": "Contacta a nuestro equipo de soporte para asistencia",
        "step2": "Proporciona los detalles de tu cuenta y la razón de la desactivación",
        "step3": "Espera la revisión de la cuenta y reactivación",
        "emailSupport": "Soporte por Email",
        "note": "Nota:",
        "noteText": "Los datos de tu cuenta se conservan y serán restaurados al reactivarse. Las actividades de trading están temporalmente suspendidas por razones de seguridad."
      }
    },
    "errors": {
      "fillAllFields": "Por favor completa todos los campos requeridos",
      "updateEmailFailed": "Error al actualizar la dirección de email",
      "changePasswordFailed": "Error al cambiar la contraseña",
      "passwordsNotMatch": "Las contraseñas no coinciden",
      "enable2FAFailed": "Error al habilitar 2FA",
      "verify2FAFailed": "Error al verificar el código 2FA",
      "disable2FAFailed": "Error al deshabilitar 2FA",
      "disable2FAVerifyFailed": "Error al verificar el código de deshabilitación 2FA",
      "deleteAccountFailed": "Error al eliminar la cuenta",
      "invalidVerificationCode": "Por favor ingresa un código de verificación válido",
      "invalid6DigitCode": "Por favor ingresa un código válido de 6 dígitos"
    },
    "success": {
      "verificationEmailSent": "Email de Verificación Enviado",
      "verificationEmailDescription": "Se ha enviado un email de verificación a {{email}}. Por favor revisa tu bandeja de entrada.",
      "passwordChanged": "Contraseña Cambiada",
      "passwordChangedDescription": "Tu contraseña ha sido cambiada exitosamente.",
      "2FACodeSent": "Código 2FA Enviado",
      "2FACodeSentDescription": "Se ha enviado un código de verificación a tu dirección de email.",
      "2FAEnabled": "2FA Habilitado",
      "2FAEnabledDescription": "La autenticación de dos factores ha sido habilitada para tu cuenta.",
      "2FADisabled": "2FA Deshabilitado",
      "2FADisabledDescription": "La autenticación de dos factores ha sido deshabilitada para tu cuenta.",
      "verificationCodeSent": "Código de Verificación Enviado",
      "verificationCodeSentDescription": "Se ha enviado un código de verificación a tu dirección de email.",
      "accountDeleted": "Cuenta Eliminada",
      "accountDeletedDescription": "Tu cuenta ha sido eliminada permanentemente."
    }
  },
  "accessSecurity": {
    "title": "Acceso y Seguridad",
    "subtitle": "Monitorea la seguridad de tu cuenta y actividad de inicio de sesión",
    "totalLogins": "Inicios de Sesión Totales",
    "successRate": "Tasa de Éxito",
    "uniqueIPs": "IPs Únicas",
    "twoFactorStatus": "Estado 2FA",
    "enabled": "Habilitado",
    "disabled": "Deshabilitado",
    "currentSession": "Sesión Actual",
    "currentSessionDescription": "Información sobre tu sesión de inicio actual",
    "lastLoginActivity": "Última Actividad de Inicio de Sesión",
    "lastLoginDescription": "Información sobre tu sesión de inicio de sesión más reciente",
    "recentLoginActivity": "Actividad de Inicio Reciente",
    "recentLoginDescription": "Tus intentos de inicio de sesión y sesiones recientes",
    "refresh": "Actualizar",
    "ipAddress": "Dirección IP",
    "timestamp": "Marca de Tiempo",
    "status": "Estado",
    "userAgent": "Agente de Usuario",
    "successful": "Exitoso",
    "failed": "Fallido",
    "noLoginActivity": "No se encontró actividad de inicio de sesión",
    "currentDevice": "Dispositivo Actual",
    "location": "Ubicación",
    "sessionStart": "Inicio de Sesión",
    "loginTime": "Hora de Inicio de Sesión",
    "browser": "Navegador",
    "never": "Nunca",
    "unknown": "Desconocido",
    "reason": "Razón:",
    "lastThirtyDays": "Últimos 30 días",
    "loginSuccessRate": "Tasa de éxito de inicio de sesión",
    "differentLocations": "Diferentes ubicaciones",
    "authenticationRequired": "Autenticación Requerida",
    "authenticationRequiredDescription": "Por favor inicia sesión para ver tu información de seguridad",
    "errors": {
      "authenticationError": "Error de Autenticación",
      "authenticationErrorDescription": "Por favor inicia sesión para acceder a la información de seguridad",
      "networkError": "Error de Red",
      "networkErrorDescription": "Error al cargar los datos de seguridad. Por favor intenta de nuevo.",
      "refreshFailed": "Error al Actualizar",
      "refreshFailedDescription": "Error al actualizar los datos de seguridad. Por favor intenta de nuevo."
    },
    "success": {
      "dataRefreshed": "Datos Actualizados",
      "dataRefreshedDescription": "Los datos de seguridad se han actualizado exitosamente"
    }
  },
  "tiers": {
    "title": "Gestión de Niveles",
    "currentTier": "Nivel Actual",
    "choosePlan": "Elige Tu Plan",
    "tier1": {
      "name": "Nivel 1",
      "subtitle": "Gratis",
      "description": "Perfecto para comenzar con señales básicas de trading",
      "features": [
        "Señales básicas de trading",
        "Ejecución manual de operaciones",
        "Soporte de la comunidad",
        "Análisis básico del mercado"
      ]
    },
    "tier2": {
      "name": "Nivel 2",
      "subtitle": "Acceso por 30 días",
      "description": "Características avanzadas para traders serios",
      "features": [
        "Señales avanzadas de trading con IA",
        "Capacidades de auto-trading",
        "Soporte prioritario",
        "Análisis avanzado",
        "Herramientas de gestión de riesgo"
      ]
    },
    "tier3": {
      "name": "Nivel 3",
      "subtitle": "NFT Requerido",
      "description": "Nivel premium con características exclusivas",
      "features": [
        "Señales premium de trading",
        "Auto-trading avanzado",
        "Soporte VIP",
        "Insights exclusivos del mercado",
        "Estrategias personalizadas"
      ]
    },
    "activate": "Activar",
    "current": "Actual",
    "paymentRequired": "Pago Requerido",
    "nftRequired": "NFT Requerido",
    "membershipStatus": "Estado de Membresía",
    "active": "Activo",
    "expired": "Expirado",
    "daysRemaining": "Días restantes",
    "expiresOn": "Expira el",
  },
  "apiCredentials": {
    "title": "Credenciales API",
    "description": "Gestiona tus credenciales API de intercambio para trading",
    "addCredentials": "Agregar Credenciales API",
    "exchange": "Intercambio",
    "exchanger": "Exchanger",
    "apiKey": "Clave API",
    "apiSecret": "Secreto API",
    "secretKey": "Clave Secreta",
    "passphrase": "Frase de Paso",
    "testConnection": "Probar Conexión",
    "save": "Guardar Credenciales",
    "edit": "Editar",
    "delete": "Eliminar",
    "status": "Estado",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "invalid": "Inválido",
    "active": "Activo",
    "testing": "Probando...",
    "connectionSuccess": "Conexión exitosa",
    "connectionFailed": "Conexión fallida",
    "credentialsAdded": "Credenciales API agregadas exitosamente",
    "credentialsUpdated": "Credenciales API actualizadas exitosamente",
    "credentialsDeleted": "Credenciales API eliminadas exitosamente",
    "credentialAddedLimitReached": "Credencial agregada (límite alcanzado)",
    "requiredMarketType": "Tipo de Mercado Requerido",
    "connectedTo": "Conectado a",
    "connectionNeedsAttention": "La conexión a",
    "needsAttention": "necesita atención",
    "lastUpdated": "Última actualización",
    "updateCredentialsMessage": "Por favor actualiza tus credenciales API para continuar trading",
    "disconnect": "Desconectar",
    "disconnecting": "Desconectando...",
    "setAsActive": "Establecer como Activo",
    "activating": "Activando...",
    "autoTrading": "Trading Automático",
    "enableAutoTradingDesc": "Habilitar trading automatizado para este intercambio",
    "tier2LimitReached": "Límite de Nivel 2 alcanzado: hasta dos credenciales CEX permitidas.",
    "add": "Agregar",
    "update": "Actualizar",
    "connectionValidated": "¡Conexión validada!",
    "autoTradingStatusChanged": "El trading automático ha sido",
    "marketTypes": {
      "futures": "Futuros",
      "spot": "Spot",
      "binanceNote": "Trading de futuros - apalancamiento hasta 125x disponible",
      "binanceUsNote": "Trading spot con margen - apalancamiento hasta 3x disponible",
      "krakenNote": "Trading de futuros - apalancamiento hasta 100x disponible",
      "bybitNote": "Trading de futuros - apalancamiento hasta 100x disponible",
      "hyperliquidNote": "Trading de futuros perpetuos - apalancamiento hasta 50x disponible",
      "standardNote": "Trading spot estándar",
    },
    "errors": {
      "loadFailed": "Error al cargar credenciales",
      "keysRequired": "Se requieren Clave API y Clave Secreta",
      "tierUndetermined": "No se puede determinar el nivel de usuario",
      "tier1Limit": "Nivel 1 permite solo una credencial API",
      "tier2PerCex": "Nivel 2 permite solo una credencial por CEX",
      "tier2Limit": "Nivel 2 permite hasta dos credenciales (una por CEX)",
      "tier3Limit": "Nivel 3 permite solo una credencial para todos los CEXs",
      "saveFailed": "Error al guardar",
      "validationFailed": "Validación fallida",
      "activationFailed": "Activación fallida",
      "deactivationFailed": "Desactivación fallida",
      "noCredentials": "No se encontraron credenciales para este intercambio",
      "autoTradingUpdateFailed": "Error al Actualizar Trading Automático",
      "autoTradingUpdateFailedDesc": "Error al actualizar configuración de trading automático",
    },
    "success": {
      "credentialsSaved": "Credenciales guardadas",
      "connectionSuccessful": "Conexión exitosa",
      "activated": "Activado",
      "deactivated": "Desactivado",
      "autoTradingEnabled": "Trading Automático Habilitado",
      "autoTradingDisabled": "Trading Automático Deshabilitado",
    }
  },
  "referrals": {
    "title": "Panel de Referencias",
    "loading": "Cargando panel de referencias...",
    "referralLink": "Enlace de Referencia",
    "referralLinkDescription": "Comparte este enlace para ganar {{rate}}% de los pagos de participación en ganancias de tus referidos.",
    "tierNames": {
      "tier1": "Nivel 1",
      "tier2": "Nivel 2",
      "tier3": "Nivel 3"
    },
    "settings": {
      "title": "Configuración",
      "referralSettings": "Configuración de Referencias",
      "solanaWalletAddress": "Dirección de Billetera Solana",
      "walletPlaceholder": "Ingresa tu dirección de billetera Solana para pagos",
      "minimumPayoutAmount": "Cantidad Mínima de Pago ($)",
      "enableAutomaticPayments": "Habilitar pagos automáticos",
      "autoPaymentEnabled": "Cuando esté habilitado, recibirás automáticamente los pagos de referencias cuando venzan.",
      "autoPaymentDisabled": "Cuando esté deshabilitado, no recibirás ningún pago de referencias hasta que esto se habilite nuevamente.",
      "saveSettings": "Guardar Configuración",
      "importantWarning": "Advertencia Importante:",
      "warnings": {
        "ensureCorrectAddress": "Por favor asegúrate de que tu dirección de billetera Solana sea correcta",
        "doubleCheckAddress": "Verifica dos veces la dirección antes de guardar",
        "notResponsible": "DeepTrade NO es responsable por pagos enviados a direcciones incorrectas o inválidas",
        "cannotRecover": "Los fondos perdidos debido a direcciones incorrectas no se pueden recuperar"
      },
      "minimumPayoutRequirements": "Requisitos de Pago Mínimo:",
      "requirements": {
        "minimumAmount": "Cantidad mínima de pago: $10.00 USDT",
        "gasFeeDeducted": "Las comisiones de gas de la red Solana se deducirán del pago",
        "estimatedGasFee": "Comisión de gas estimada: ~0.001 SOL (~$0.10-$0.50)",
        "payoutsProcessed": "Los pagos se procesan en USDT en la red Solana"
      }
    },
    "overview": {
      "totalReferrals": "Total de Referencias",
      "activeCount": "{{count}} activos",
      "totalEarnings": "Ganancias Totales",
      "totalPaid": "${{amount}} pagados",
      "pendingPayout": "Pago Pendiente",
      "requestPayout": "Solicitar Pago",
      "earningRate": "Tasa de Ganancias"
    },
    "actions": {
      "copy": "Copiar",
      "generateNew": "Generar Nuevo"
    },
    "recentActivity": {
      "recentReferrals": "Referencias Recientes",
      "recentEarnings": "Ganancias Recientes",
      "noReferrals": "Aún no hay referencias. ¡Comienza a compartir tu enlace!",
      "noEarnings": "Aún no hay ganancias. ¡Los referidos necesitan comenzar a hacer trading!",
      "earned": "${{amount}} ganados"
    },
    "status": {
      "verified": "Verificado",
      "pending": "Pendiente",
      "paid": "Pagado"
    },
    "messages": {
      "copied": "¡Copiado!",
      "linkCopied": "Enlace de referencia copiado al portapapeles",
      "newCodeGenerated": "Nuevo código de referencia generado",
      "profileUpdated": "Perfil actualizado exitosamente",
      "payoutRequestSubmitted": "Solicitud de pago enviada"
    },
    "errors": {
      "failedToLoadData": "Error al cargar datos de referencias",
      "failedToGenerateCode": "Error al generar nuevo código",
      "invalidMinimumPayout": "Pago Mínimo Inválido",
      "minimumPayoutRequired": "El pago mínimo debe ser al menos $10.00",
      "invalidWalletAddress": "Dirección de Billetera Inválida",
      "validWalletRequired": "Por favor ingresa una dirección de billetera Solana válida",
      "failedToUpdateProfile": "Error al actualizar perfil",
      "failedToRequestPayout": "Error al solicitar pago"
    }
  },

  "paperTradingHelp": {
    "title": "Guía de Trading de Simulación",
    "whatIsPaperTrading": "¿Qué es el Trading de Simulación?",
    "whatIsPaperTradingDesc": "El trading de simulación es un entorno de trading simulado que te permite practicar estrategias de trading usando dinero virtual en lugar de fondos reales. Es la forma perfecta de probar nuestro sistema de trading con IA sin ningún riesgo financiero.",
    "keyBenefits": "Beneficios Clave",
    "riskFree": "Aprendizaje Sin Riesgo",
    "riskFreeDesc": "Practica con fondos virtuales - sin dinero real en riesgo",
    "realMarketData": "Datos de Mercado Reales",
    "realMarketDataDesc": "Experimenta condiciones de mercado en vivo y movimientos de precios",
    "aiTradingSystem": "Sistema de Trading con IA",
    "aiTradingSystemDesc": "Prueba nuestras señales avanzadas de IA en un entorno seguro",
    "buildConfidence": "Construye Confianza",
    "buildConfidenceDesc": "Desarrolla tus habilidades de trading antes de usar dinero real",
    "howItWorks": "Cómo Funciona",
    "step1": "Cambiar a Modo Simulación",
    "step1Desc": "Cambia el interruptor de modo de trading para habilitar el trading de simulación",
    "step2": "Balance Virtual",
    "step2Desc": "Comienza con $10,000 de balance virtual (se puede reiniciar)",
    "step3": "Señales de IA",
    "step3Desc": "Nuestra IA genera señales de trading basadas en datos de mercado reales",
    "step4": "Operaciones Simuladas",
    "step4Desc": "Las operaciones se ejecutan virtualmente - rastrea tu rendimiento",
    "importantNotes": "Notas Importantes",
    "noRealMoney": "Sin Dinero Real",
    "noRealMoneyDesc": "El trading de simulación usa solo fondos virtuales. No ocurren ganancias o pérdidas reales.",
    "noRealFees": "Sin Comisiones Reales",
    "noRealFeesDesc": "Las comisiones de trading y el deslizamiento se simulan para una experiencia realista.",
    "performanceTracking": "Seguimiento de Rendimiento",
    "performanceTrackingDesc": "Todas las estadísticas y análisis se basan únicamente en operaciones simuladas.",
    "readyToStart": "¿Listo para Comenzar?",
    "readyToStartDesc": "¡Cambia el interruptor de \"Modo de Trading\" a \"Simulación\" y comienza a practicar con fondos virtuales hoy!",
    "buildConfidenceFooter": "💪 ¡Construye confianza con el trading de simulación antes de arriesgar dinero real!",
    "resetModal": {
      "title": "Reiniciar Cuenta de Trading de Simulación",
      "warning": "Advertencia: Esta acción no se puede deshacer",
      "warningDesc": "Esto eliminará permanentemente todo tu historial de trading de simulación y reiniciará tu balance virtual.",
      "resetLimitReached": "Límite Diario de Reinicio Alcanzado",
      "resetLimitReachedDesc": "Has usado los 3 reinicios para hoy. El límite se reinicia a medianoche UTC.",
      "resetsRemaining": "Reinicios restantes hoy: {{count},",
      "currentBalance": "Balance Actual: ${{balance},",
      "resetToDefault": "Reiniciar a $10,000 por defecto",
      "customBalance": "Establecer balance personalizado",
      "customBalanceDesc": "Ingresa un balance inicial personalizado (mínimo $1,000)",
      "confirmationRequired": "Escribe 'RESET' para confirmar",
      "confirmationPlaceholder": "Escribe RESET aquí...",
      "confirmationRequiredError": "Por favor escribe 'RESET' para confirmar",
      "invalidBalance": "Balance Inválido",
      "invalidBalanceDesc": "Por favor ingresa un monto de balance positivo válido",
      "resetting": "Reiniciando...",
      "resetButton": "Reiniciar Cuenta",
    },
    "howItWorksModal": {
      "title": "Cómo Funciona el Trading de Simulación",
      "step1": "Comienza con $10,000 de balance virtual (configurable)",
      "step2": "Habilita el trading automático para que la IA ejecute operaciones automáticamente",
      "step3": "Monitorea el rendimiento y ajusta la configuración de riesgo según sea necesario",
      "step4": "Cambia al trading en vivo cuando tengas confianza en el sistema",
    },
    "importantNotesDetails": {
      "noRealMoneyTitle": "Sin Dinero Real:",
      "noRealMoneyDesc": "El trading de simulación usa solo fondos virtuales. No ocurren ganancias o pérdidas reales.",
      "noFeesTitle": "Sin Comisiones:",
      "noFeesDesc": "El trading de simulación no genera comisiones de participación en ganancias ya que no se obtienen ganancias reales.",
      "resetLimitTitle": "Límite de Reinicio:",
      "resetLimitDesc": "Puedes reiniciar tu cuenta de simulación hasta 3 veces por día.",
    },
    "benefits": {
      "title": "Beneficios del Trading de Simulación",
      "riskFreeLearning": "Aprendizaje Sin Riesgo",
      "riskFreeLearningDesc": "Practica sin perder dinero real mientras aprendes cómo funciona nuestro sistema de IA",
      "strategyTesting": "Prueba de Estrategias",
      "strategyTestingDesc": "Prueba diferentes configuraciones de riesgo y ve cómo funcionan con el tiempo",
      "realMarketData": "Datos de Mercado Reales",
      "realMarketDataDesc": "Usa precios de mercado en vivo y pronósticos de ML reales para una experiencia auténtica",
    },
    "gettingStarted": {
      "title": "¿Listo para Comenzar?",
      "description": "¡Cambia el interruptor \"Modo de Trading\" a \"Simulación\" y comienza a practicar con fondos virtuales hoy!",
      "buildConfidenceFooter": "💪 ¡Construye confianza con el trading de simulación antes de arriesgar dinero real!",
    },
    "perfectForBeginners": "💡 ¡Perfecto para principiantes y traders experimentados que quieren probar nuevas estrategias!",
    "availableToAllTitle": "Disponible para Todos:",
    "availableToAllDesc": "El trading de simulación está disponible para todos los usuarios independientemente del nivel de tier.",
    "gotItThanks": "¡Entendido, gracias!",
  },

  "paperTradingDashboard": {
    "performance": {
      "title": "Rendimiento del Trading de Simulación",
      "refresh": "Actualizar",
      "reset": "Reiniciar",
      "totalReturn": "Retorno Total",
    },

    "errors": {
      "loadFailed": "Error al cargar datos del trading de simulación",
    }
  },
  "tradingSignalStatus": {
    "title": "Estado de la Señal de Trading",
    "description": "Estado en vivo de la transmisión de señales del sistema",
    "signalLabel": "Señal",
    "confidenceLabel": "Confianza de la Señal de IA",
    "lastUpdateLabel": "Última act.",
    "errorLoading": "Error al cargar el estado de trading",
    "signals": {
      "HOLD": "MANTENER",
      "BUY": "COMPRAR",
      "SELL": "VENDER",
      "LONG": "Largo",
      "SHORT": "Corto",
      "long": "Largo",
      "short": "Corto"
    }
  },
  "tier": {
    "choosePlan": "Elige Tu Plan",
    "membershipStatus": {
      "active": "Activo",
      "expired": "Expirado",
      "daysRemaining": "Días restantes:",
      "expiresOn": "Expira el:"
    },
    "modals": {
      "activateTier": "Activar Nivel {{tierName}}",
      "confirmActivation": "¿Estás seguro de que quieres activar el nivel {{tierName}}?",
      "confirmTierChange": "Confirmar Cambio de Nivel",
      "confirmSwitch": "¿Estás seguro de que quieres cambiar al nivel {{tierName}}?",
      "cancel": "Cancelar",
      "activate": "Activar",
      "confirm": "Confirmar"
    },
    "tiers": {
      "starter": {
        "name": "Nivel 1: Principiante",
        "price": "Gratis",
        "description": "Perfecto para empezar",
        "features": [
          "Señales de Trading Básicas",
          "Apalancamiento de Trading hasta 2.5x",
          "Limitado a Un Acceso API",
          "40% de Comisión por Participación en Ganancias"
        ]
      },
      "pro": {
        "name": "Nivel 2: Pro",
        "description": "Para traders serios",
        "accessInstructions": "Para acceder a este nivel, usa el botón de billetera en la barra de navegación superior para conectar tu billetera Solana y pagar por acceso de 30 días.",
        "features": [
          "Señales de Trading Avanzadas",
          "Apalancamiento de Trading hasta 5x",
          "Limitado a Dos Accesos API",
          "20% de Comisión por Participación en Ganancias"
        ]
      },
      "nftElite": {
        "name": "Nivel 3: NFT Elite",
        "price": "De por vida",
        "description": "Para coleccionistas verificados de NFT Capitolchilax.",
        "visitWebsite": "Visita capitolchilax.com",
        "accessInstructions": "Para acceder a este nivel, usa el botón de billetera en la barra de navegación superior para conectar y verificar tu elegibilidad NFT.",
        "features": [
          "Señales de Trading Avanzadas",
          "Apalancamiento de Trading hasta 10x",
          "Conexiones API Ilimitadas",
          "10% de Comisión por Participación en Ganancias",
          "Sin Cuota de Membresía Mensual"
        ]
      }
    },
    "status": {
      "currentTier": "Nivel Actual",
      "alreadyUnlocked": "Ya Desbloqueado",
      "yourCurrentTier": "Tu Nivel Actual",
      "currentlyOn": "Actualmente estás en {{tierName}}"
    },
    "buttons": {
      "paymentRequired": "Pago Requerido",
      "connectWallet": "Conectar Billetera",
      "nftRequired": "NFT Requerido",
      "select": "Seleccionar {{tierName}}",
      "activate": "Activar {{tierName}}",
      "payToReactivate": "Pagar para Reactivar",
      "payWithToken": "Pagar con {{token}}",
      "connectWalletFirst": "Conectar Billetera Primero",
      "proceedWithPayment": "Proceder con el Pago"
    },
    "nft": {
      "verifyingOwnership": "Verificando propiedad del NFT...",
      "nftRequired": "Necesitas poseer un NFT específico para acceder a este nivel",
      "nftOwned": "Posees un NFT de la colección requerida."
    },
    "payment": {
      "thirtyDaysAccess": "Acceso de 30 Días",
      "thirtyDaysAccessDue": "Acceso de 30 Días Vencido",
      "paymentDetails": "Detalles del Pago",
      "amount": "Cantidad:",
      "network": "Red:",
      "wallet": "Billetera:",
      "connectionStatus": "Estado de Conexión:",
      "connected": "Conectado",
      "disconnected": "Desconectado",
      "processing": "Procesando Pago",
      "processingDescription": "Por favor confirma la transacción en tu billetera y espera la confirmación...",
      "successful": "¡Pago Exitoso!",
      "successDescription": "Tu pago ha sido procesado exitosamente. Tu nivel será actualizado en breve.",
      "failed": "Pago Fallido",
      "failedDescription": "Hubo un error procesando tu pago. Por favor intenta de nuevo.",
      "tryAgain": "Intentar de Nuevo",
      "thirtyDaysAccessDescription": "Completa tu pago por acceso de 30 días para activar las características Pro.",
      "importantNotes": "Notas Importantes",
      "paymentWarnings": [
        "Asegúrate de tener suficiente {{token}} en tu billetera",
        "Mantén algo de SOL para comisiones de transacción (~0.001 SOL)",
        "El pago será procesado en la red principal de Solana",
        "La transacción es irreversible una vez confirmada"
      ]
    },
    "paymentHistory": {
      "title": "Historial de Pagos",
      "profitShare": "Participación en Ganancias",
      "thirtyDaysAccess": "Acceso de 30 Días",
      "billingPeriod": "${{amount}} vence para {{startDate}} - {{endDate}}"
    },
    "errors": {
      "paymentRequired": "Debes pagar tus comisiones pendientes de participación en ganancias (${{amount}}) antes de cambiar de nivel.",
      "downgradeNotAllowed": "No puedes degradar del Nivel {{currentTier}} al Nivel {{newTier}}. Solo puedes actualizar a niveles superiores.",
      "walletConnectionRequired": "Por favor conecta tu billetera Solana para acceder al Nivel 2.",
      "nftRequired": "Necesitas poseer un NFT específico para acceder a este nivel.",
      "membershipExpired": "Tu membresía de Nivel 2 ha expirado. Has sido degradado al nivel Principiante.",
      "walletDisconnected": "Tu estado de nivel ha sido preservado.",
      "walletDisconnectedWithDays": "Tu acceso de Nivel 2 permanece activo por {{days}} días más.",
      "couldNotValidate": "Tu estado de nivel ha sido preservado. Reconecta tu billetera para hacer pagos.",
      "failedToFetchTier": "Error al obtener el estado del nivel",
      "errorLoadingTier": "Error cargando información del nivel",
      "dataFetchError": "Error al obtener datos del nivel: {{error}}",
      "walletNotConnected": "Por favor conecta tu billetera Solana para proceder con el pago.",
      "paymentFailed": "Hubo un error procesando tu pago. Por favor intenta de nuevo.",
      "paymentSuccessful": "¡Tu pago de {{type}} ha sido procesado exitosamente!"
    },
    "profitShare": {
      "paymentDueTitle": "Pago de Participación en Ganancias Vencido",
      "accountDisabled": "Cuenta Deshabilitada",
      "status": "Estado de Participación en Ganancias",
      "paymentWasDue": "El pago venció:",
      "paymentDue": "Pago vence:",
      "nextPaymentDeadline": "Próxima fecha límite de pago:",
      "payNow": "Pagar Ahora",
      "payToReactivate": "Pagar para Reactivar",
      "overdue": "VENCIDO",
      "accountDisabledMessage": "Cuenta Deshabilitada - Pago Requerido",
      "paymentOverdue": "Pago Vencido",
      "paymentDueSoon": "Pago Vence Pronto",
      "wasDue": "Venció:",
      "due": "Vence:",
      "youOwe": "Debes ${{amount}} en comisiones de participación en ganancias",
      "allCaughtUp": "Sin comisiones pendientes de participación en ganancias - ¡Estás al día! 🎉",
      "scheduleInfo": "Los pagos de participación en ganancias vencen cada sábado a las 0:00 GMT",
      "disableWarning": "Las cuentas se deshabilitan cada sábado a las 0:00 GMT por comisiones impagadas",
      "deadlineApproaching": "Fecha Límite de Pago Acercándose",
      "deadlineMessage": "Tu pago de participación en ganancias de ${{amount}} vence el sábado a las 0:00 GMT. Tu cuenta será automáticamente deshabilitada si no se recibe el pago antes de la fecha límite.",
      "accountTradingDisabled": "Trading de Cuenta Deshabilitado",
      "accountDisabledDescription": "Tu cuenta de trading está deshabilitada debido a comisiones pendientes de participación en ganancias. Paga ${{amount}} para reactivar el trading.",
      "accountSuspendedWarning": "⚠️ Tu cuenta ha sido deshabilitada debido a comisiones impagadas. El trading está suspendido hasta que se realice el pago.",
      "disabledOn": "Deshabilitada el:",
      "deadline": "Fecha límite:"
    },
    "coupon": {
      "redeemButton": "¿Tienes un Cupón? Canjéalo Aquí",
      "redeemDescription": "Actualiza tu nivel instantáneamente con un código de cupón"
    },
    "pricing": {
      "free": "Gratis",
      "lifetime": "De por vida",
      "thirtyDayAccess": "${{price}} por acceso de 30 días"
    },
    "success": {
      "tierUpdated": "Tu nivel ha sido actualizado a {{tierName}}.",
      "tierActivated": "Tu nivel ha sido actualizado exitosamente.",
      "paymentSuccessful": "¡Tu pago de {{type}} ha sido procesado exitosamente!"
    },
    "notifications": {
      "accountDisabled": {
        "title": "🚫 Cuenta Deshabilitada",
        "description": "Tu cuenta ha sido deshabilitada debido a comisiones impagadas de participación en ganancias de ${{amount}}. Por favor realiza un pago para reactivar tu cuenta."
      },
      "paymentOverdue": {
        "title": "⚠️ Pago Vencido",
        "description": "Tu pago de participación en ganancias de ${{amount}} está vencido. Tu cuenta puede ser deshabilitada pronto."
      },
      "paymentReminder": {
        "title": "⏰ Recordatorio de Pago",
        "description": "Tu pago de participación en ganancias de ${{amount}} vence el sábado 0:00 GMT. Por favor paga para evitar la suspensión de cuenta."
      }
    }
  },
  "help": {
    "title": "Ayuda y Soporte",
    "description": "Encuentra respuestas a preguntas comunes, revisa nuestras políticas legales y ponte en contacto con nuestro equipo de soporte.",
    "faqTab": "Preguntas Frecuentes",
    "legalTab": "Legal",
    "contactTab": "Contacto",
    "faqSection": {
      "categories": {
        "general": "General",
        "trading": "Trading",
        "tiers": "Niveles",
        "setup": "Configuración",
        "security": "Seguridad",
        "billing": "Facturación"
      },
      "items": {
        "whatIsDeepTrade": {
          "question": "¿Qué es DeepTrade?",
          "answer": "DeepTrade es una plataforma de trading de criptomonedas impulsada por IA que proporciona señales de trading automatizadas y herramientas de gestión de portafolio usando algoritmos avanzados de aprendizaje automático."
        },
        "howSignalsWork": {
          "question": "¿Cómo funcionan las señales de trading?",
          "answer": "Nuestra IA analiza datos de mercado en tiempo real para generar señales de compra/venta con puntos de entrada, stop losses y niveles de toma de ganancias. Puedes ejecutarlas manualmente o habilitar el auto-trading."
        },
        "tierLevels": {
          "question": "¿Cuáles son los diferentes niveles de tier?",
          "answer": "Tier 1 (Gratis): Señales básicas. Tier 2 ($50/mes): Señales avanzadas + auto-trading. Tier 3 (NFT requerido): Características premium + soporte prioritario."
        },
        "connectExchange": {
          "question": "¿Cómo conecto mi cuenta de exchange?",
          "answer": "Ve a Credenciales API en tu dashboard, agrega tus claves API del exchange (recomendado solo lectura), y nuestro sistema validará la conexión."
        },
        "dataSecure": {
          "question": "¿Están seguros mis datos?",
          "answer": "Sí, usamos encriptación estándar de la industria, nunca almacenamos tus claves privadas, y recomendamos acceso de solo lectura API para máxima seguridad."
        },
        "profitShares": {
          "question": "¿Cómo funcionan las participaciones en ganancias?",
          "answer": "Para usuarios Tier 2+, cobramos un pequeño porcentaje de las ganancias generadas a través de nuestras señales. Esto alinea nuestros intereses con tu éxito."
        },
        "cancelSubscription": {
          "question": "¿Puedo cancelar mi suscripción en cualquier momento?",
          "answer": "Sí, puedes degradar o cancelar tu suscripción en cualquier momento. Mantendrás el acceso hasta el final de tu período de facturación actual."
        },
        "supportedExchanges": {
          "question": "¿Qué exchanges están soportados?",
          "answer": "Actualmente soportamos exchanges principales incluyendo Binance, Coinbase Pro, Kraken, y otros. Revisa nuestra página de Credenciales API para la lista completa."
        }
      }
    },
    "legal": {
      "documents": "Documentos Legales",
      "englishNotice": "Siempre mostrado en inglés para claridad legal",
      "privacy": {
        "title": "Política de Privacidad",
        "description": "Nuestra Política de Privacidad describe cómo recopilamos, usamos y protegemos tu información personal cuando usas los servicios de DeepTrade. Estamos comprometidos a mantener la privacidad y seguridad de tus datos.",
        "highlights": {
          "title": "Aspectos Clave de Privacidad:",
          "item1": "Solo recopilamos información necesaria para proporcionar nuestros servicios",
          "item2": "Tus datos de trading están encriptados y almacenados de forma segura",
          "item3": "Nunca vendemos tu información personal a terceros",
          "item4": "Tienes control sobre tus datos y configuraciones de privacidad"
        },
        "viewFull": "Ver Política de Privacidad Completa"
      },
      "terms": {
        "title": "Términos de Servicio",
        "description": "Nuestros Términos de Servicio rigen tu uso de la plataforma y servicios de DeepTrade. Al usar nuestra plataforma, aceptas estos términos y condiciones.",
        "highlights": {
          "title": "Aspectos Clave de los Términos:",
          "item1": "Derechos y restricciones de uso de la plataforma",
          "item2": "Responsabilidades y obligaciones del usuario",
          "item3": "Disponibilidad y limitaciones del servicio",
          "item4": "Políticas de terminación y suspensión de cuenta"
        },
        "viewFull": "Ver Términos de Servicio Completos"
      },
      "risks": {
        "title": "Divulgación de Riesgos"
      }
    },
    "contact": {
      "title": "Contactar Soporte",
      "form": {
        "name": "Nombre",
        "email": "Correo Electrónico",
        "subject": "Asunto",
        "message": "Mensaje",
        "sendMessage": "Enviar Mensaje",
        "sending": "Enviando...",
        "placeholders": {
          "name": "Tu nombre completo",
          "email": "tu.correo@ejemplo.com",
          "subject": "Descripción breve de tu problema",
          "message": "Por favor describe tu problema en detalle..."
        }
      },
      "guidelines": {
        "title": "Pautas de Soporte",
        "before": {
          "title": "Antes de Contactar Soporte",
          "item1": "Revisa primero esta sección de Preguntas Frecuentes",
          "item2": "Revisa la configuración de tu cuenta",
          "item3": "Verifica tus credenciales API",
          "item4": "Revisa nuestra página de estado para problemas conocidos"
        },
        "when": {
          "title": "Al Contactar Soporte",
          "item1": "Incluye el correo de tu cuenta",
          "item2": "Describe el problema en detalle",
          "item3": "Proporciona capturas de pantalla si es aplicable",
          "item4": "Incluye mensajes de error"
        },
        "notice": {
          "title": "Aviso Importante",
          "message": "Nunca te pediremos tus claves privadas, contraseñas o claves secretas API. Mantén esta información segura y nunca la compartas con nadie."
        }
      },
      "errors": {
        "missingInformation": "Información Faltante",
        "fillAllFields": "Por favor completa todos los campos antes de enviar.",
        "failedToSend": "Error al enviar mensaje",
        "error": "Error",
        "tryAgainLater": "Error al enviar mensaje. Por favor intenta de nuevo más tarde."
      },
      "success": {
        "messageSent": "¡Mensaje Enviado!",
        "thankYou": "Gracias por contactarnos. Te responderemos dentro de 24-48 horas."
      }
    }
  },
  "redeemCoupon": {
    "title": "Canjear Cupón",
    "subtitle": "Ingresa tu código de cupón para mejorar tu nivel",
    "currentTier": "Nivel Actual:",
    "couponCode": "Código de Cupón",
    "placeholder": "Ingresa código de cupón (ej., DTABC123)",
    "formatHint": "El código debe tener 4-20 caracteres, solo letras y números",
    "redeemButton": "Canjear Cupón",
    "redeeming": "Canjeando...",
    "backToTier": "← Volver a Gestión de Niveles",
    "tierNames": {
      "starter": "Principiante (Gratis)",
      "pro": "Pro (Premium)",
      "vip": "VIP (Elite)",
      "unknown": "Desconocido"
    },
    "howItWorks": {
      "title": "Cómo funciona:",
      "steps": [
        "Ingresa tu código de cupón arriba",
        "Tu nivel se actualizará automáticamente",
        "Obtendrás acceso inmediato a nuevas funciones",
        "Cada cupón solo se puede usar una vez"
      ]
    },
    "errors": {
      "invalidInput": "Entrada Inválida",
      "enterCouponCode": "Por favor ingresa un código de cupón",
      "invalidFormat": "Formato Inválido",
      "formatRequirement": "El código de cupón debe tener 4-20 caracteres, solo letras y números",
      "redemptionFailed": "Canje Fallido",
      "failedToRedeem": "Error al canjear cupón",
      "networkError": "Error de Red",
      "connectionFailed": "Error al conectar con el servidor. Por favor intenta de nuevo."
    },
    "success": {
      "redeemed": "¡Cupón Canjeado Exitosamente!",
      "validFor": "(Válido por {{days}} días)"
    }
  },
  "oauthCallback": {
    "loading": {
      "title": "Autenticando...",
      "description": "Por favor espere mientras completamos su autenticación."
    },
    "error": {
      "title": "Error de Autenticación",
      "returnToLogin": "Volver al Inicio de Sesión",
      "tryAgain": "Intentar de Nuevo"
    },
    "completing": {
      "title": "Completando Autenticación",
      "description": "Por favor espere mientras lo conectamos..."
    },
    "errors": {
      "authenticationFailed": "Falló la autenticación",
      "noAuthorizationCode": "No se recibió código de autorización del proveedor OAuth",
      "invalidServerResponse": "Respuesta inválida del servidor",
      "unexpectedError": "Ocurrió un error inesperado durante la autenticación",
      "noAdditionalDetails": "No hay detalles adicionales disponibles"
    }
  },
  "resetPassword": {
    "validation": {
      "minLength": "La contraseña debe tener al menos 8 caracteres",
      "uppercase": "La contraseña debe contener al menos una letra mayúscula",
      "lowercase": "La contraseña debe contener al menos una letra minúscula",
      "number": "La contraseña debe contener al menos un número",
      "specialChar": "La contraseña debe contener al menos un carácter especial"
    },
    "errors": {
      "invalidToken": "Token Inválido",
      "invalidTokenDescription": "Este enlace de restablecimiento de contraseña es inválido o ha expirado.",
      "validationFailed": "Validación Fallida",
      "validationFailedDescription": "Error al validar el token de restablecimiento. Por favor intente de nuevo.",
      "fillAllFields": "Por favor complete todos los campos",
      "passwordsDoNotMatch": "Las contraseñas no coinciden",
      "requirementsNotMet": "Requisitos de Contraseña No Cumplidos",
      "resetFailed": "Error al restablecer la contraseña",
      "resetFailedTitle": "Restablecimiento Fallido"
    },
    "success": {
      "title": "Restablecimiento de Contraseña Exitoso",
      "description": "Su contraseña ha sido actualizada exitosamente.",
      "passwordUpdated": "✓ Contraseña Actualizada",
      "securityNote": "Ahora puede iniciar sesión con su nueva contraseña. Por seguridad, ha sido desconectado de todos los dispositivos.",
      "continueToLogin": "Continuar al Inicio de Sesión"
    },
    "validating": {
      "title": "Validando Enlace de Restablecimiento",
      "description": "Por favor espere mientras validamos su enlace de restablecimiento de contraseña..."
    },
    "invalid": {
      "title": "Enlace de Restablecimiento Inválido",
      "description": "Este enlace de restablecimiento de contraseña es inválido o ha expirado.",
      "linkInvalid": "Enlace Inválido",
      "reason1": "• El enlace de restablecimiento puede haber expirado (los enlaces expiran después de 1 hora)",
      "reason2": "• El enlace puede haber sido usado ya",
      "reason3": "• El enlace puede estar malformado o incompleto",
      "requestNewLink": "Solicitar Nuevo Enlace de Restablecimiento",
      "backToLogin": "Volver al Inicio de Sesión"
    },
    "form": {
      "title": "Restablecer Su Contraseña",
      "description": "Ingrese su nueva contraseña para {{email}}",
      "newPassword": "Nueva Contraseña",
      "newPasswordPlaceholder": "Ingrese su nueva contraseña",
      "confirmPassword": "Confirmar Nueva Contraseña",
      "confirmPasswordPlaceholder": "Confirme su nueva contraseña",
      "updating": "Actualizando Contraseña...",
      "updateButton": "Actualizar Contraseña",
      "backToLogin": "Volver al Inicio de Sesión"
    },
    "requirements": {
      "title": "Requisitos de Contraseña",
      "minLength": "• Al menos 8 caracteres de longitud",
      "caseLetters": "• Incluir letras mayúsculas y minúsculas",
      "number": "• Incluir al menos un número",
      "specialChar": "• Incluir al menos un carácter especial (!@#$%^&*(),.?\":{}|<>)"
    },
    "expiration": {
      "notice": "Este enlace de restablecimiento expira el {{time}}"
    }
  },
  "twoFAResetRequest": {
    "securityQuestions": {
      "question1": "¿Cuándo fue su última operación exitosa?",
      "question2": "¿En qué nivel se encuentra actualmente (1, 2 o 3)?",
      "question3": "¿Qué exchange utiliza principalmente para operar?"
    },
    "errors": {
      "fillRequiredFields": "Por favor complete todos los campos requeridos (correo, nombre completo y razón)",
      "submitFailed": "Error al enviar solicitud de restablecimiento 2FA",
      "requestFailed": "Solicitud Fallida"
    },
    "success": {
      "requestSubmitted": "Solicitud Enviada",
      "title": "Solicitud Enviada",
      "description": "Su solicitud de restablecimiento 2FA ha sido enviada para revisión.",
      "submittedSuccessfully": "✓ Solicitud Enviada Exitosamente",
      "email": "Correo",
      "requestId": "ID de Solicitud",
      "status": "Estado",
      "pendingReview": "Pendiente de Revisión",
      "whatHappensNext": "¿Qué sigue?",
      "step1": "1. Nuestro equipo de seguridad revisará su solicitud e información de verificación",
      "step2": "2. Podemos contactarlo para verificación adicional si es necesario",
      "step3": "3. Recibirá una notificación por correo una vez procesada",
      "step4": "4. Si se aprueba, su 2FA será deshabilitado y podrá configurarlo nuevamente",
      "backToLogin": "Volver al Inicio de Sesión",
      "submitAnother": "Enviar Otra Solicitud"
    },
    "form": {
      "title": "Solicitud de Restablecimiento 2FA",
      "description": "¿Perdió acceso a su dispositivo 2FA? Complete este formulario para solicitar un restablecimiento de nuestro equipo de seguridad.",
      "securityNotice": "⚠️ Aviso de Seguridad Importante",
      "notice1": "• Este proceso requiere revisión manual por nuestro equipo de seguridad",
      "notice2": "• Proporcione información tan precisa como sea posible para acelerar la verificación",
      "notice3": "• Información falsa resultará en rechazo de la solicitud",
      "notice4": "• Tiempo de procesamiento: 1-3 días hábiles",
      "requiredInformation": "Información Requerida",
      "emailAddress": "Dirección de Correo *",
      "fullName": "Nombre Completo *",
      "reason": "Razón para Restablecimiento 2FA *",
      "additionalVerification": "Verificación Adicional (Opcional pero Recomendado)",
      "lastLoginDate": "Fecha Aproximada del Último Inicio de Sesión",
      "accountCreationDate": "Fecha Aproximada de Creación de Cuenta",
      "recentActivity": "Actividad Reciente de la Cuenta",
      "securityQuestionsTitle": "Preguntas de Seguridad",
      "securityQuestionsDescription": "Responda estas preguntas para ayudar a verificar su identidad. Deje en blanco si no sabe.",
      "submittingRequest": "Enviando Solicitud...",
      "submitButton": "Enviar Solicitud de Restablecimiento 2FA",
      "backToLogin": "Volver al Inicio de Sesión",
      "rememberDevice": "¿Recuerda su dispositivo 2FA?",
      "tryVerification": "Intentar verificación 2FA",
      "placeholders": {
        "email": "Ingrese la dirección de correo de su cuenta",
        "fullName": "Ingrese su nombre completo como está registrado",
        "reason": "Explique por qué necesita restablecer su 2FA (ej., teléfono perdido, dispositivo roto, etc.)",
        "lastLoginDate": "ej., 15 de diciembre, 2024",
        "accountCreationDate": "ej., noviembre 2024",
        "recentActivity": "Describa actividades recientes (operaciones, cambios de nivel, pagos, etc.)",
        "yourAnswer": "Su respuesta"
      }
    }
  },
  "verify2FA": {
    "title": "Autenticación de Dos Factores",
    "description": "Se ha enviado un código de verificación de 6 dígitos a su dirección de correo",
    "form": {
      "verificationCode": "Código de Verificación",
      "placeholder": "Ingrese código de 6 dígitos",
      "verifying": "Verificando...",
      "verifyCode": "Verificar Código"
    },
    "errors": {
      "sessionExpired": "Sesión Expirada",
      "pleaseLoginAgain": "Por favor inicie sesión de nuevo.",
      "enterCode": "Por favor ingrese el código de verificación",
      "codeMustBe6Digits": "El código de verificación debe tener 6 dígitos",
      "verificationFailed": "Verificación fallida",
      "verificationFailedTitle": "Verificación Fallida",
      "invalidCode": "Código de verificación inválido",
      "failedToResendCode": "Error al reenviar código",
      "failedToResendTitle": "Error al Reenviar"
    },
    "success": {
      "loginSuccessful": "Inicio de Sesión Exitoso",
      "welcomeBack": "¡Bienvenido de vuelta!",
      "codeSent": "Código Enviado",
      "codeSentDescription": "Se ha enviado un nuevo código de verificación a su correo."
    },
    "help": {
      "needHelp": "¿Necesita ayuda?",
      "sending": "Enviando...",
      "resendCode": "Reenviar Código",
      "backToLogin": "Volver al Inicio de Sesión",
      "lostDevice": "¿Perdió su Dispositivo 2FA? Solicitar Restablecimiento",
      "didntReceiveCode": "¿No recibió el código? Revise su carpeta de spam o",
      "resendIt": "reenviarlo",
      "byContinuing": "Al continuar, acepta nuestros",
      "termsOfService": "Términos de Servicio",
      "privacyPolicy": "Política de Privacidad"
    }
  },
  "forgotPassword": {
    "errors": {
      "emailRequired": "La dirección de correo es requerida",
      "sendFailed": "Error al enviar el correo de restablecimiento de contraseña",
      "requestFailed": "Solicitud Fallida"
    },
    "success": {
      "emailSent": "Correo de Restablecimiento Enviado",
      "title": "Revise Su Correo",
      "description": "Si existe una cuenta con este correo, recibirá un enlace de restablecimiento de contraseña.",
      "emailSentTitle": "Correo Enviado",
      "emailSentMessage": "Hemos enviado un enlace de restablecimiento de contraseña a {{email}} si existe una cuenta.",
      "instruction1": "• Revise su carpeta de spam/correo no deseado si no ve el correo",
      "instruction2": "• El enlace de restablecimiento expira en 1 hora",
      "instruction3": "• Puede solicitar otro restablecimiento si es necesario",
      "sendAnother": "Enviar Otro Correo de Restablecimiento",
      "backToLogin": "Volver al Inicio de Sesión"
    },
    "form": {
      "title": "Olvidé mi Contraseña",
      "description": "Ingrese su dirección de correo y le enviaremos un enlace para restablecer su contraseña.",
      "emailAddress": "Dirección de Correo",
      "placeholder": "Ingrese su dirección de correo",
      "sending": "Enviando...",
      "sendResetLink": "Enviar Enlace de Restablecimiento",
      "backToLogin": "Volver al Inicio de Sesión",
      "noAccount": "¿No tiene una cuenta?",
      "signUp": "Registrarse",
      "lost2FA": "¿Perdió acceso a su dispositivo 2FA?",
      "request2FAReset": "Solicitar restablecimiento 2FA"
    },
    "security": {
      "title": "Nota de Seguridad",
      "note1": "• El restablecimiento de contraseña solo está disponible para cuentas tradicionales",
      "note2": "• Los usuarios de Google OAuth deben usar \"Iniciar sesión con Google\"",
      "note3": "• Los enlaces de restablecimiento expiran después de 1 hora por seguridad"
    }
  }
};
